// useSignInRecovery.js — when Clerk has signed the user in but the dialog didn't see it (live,
// 2026-10-15: a pasted code was accepted, the boxes emptied and the dialog stayed; the same code
// again gave "Invalid Action", and Start Again "Session Already Exists"). The browser then holds a
// signed-in session: make it the active one and carry on, rather than show Clerk's error.
// Also plain messages for the errors that are real (a wrong or expired code).

const ACTIVATE_TIMEOUT_MS = 8000; // setActive can be slow; the session is there either way

// the session this browser holds, if any: the one just created, else the client's latest
function getHeldSessionId(clerk, preferredId) {
  if (preferredId) return preferredId;
  const client = clerk?.client;
  return client?.lastActiveSessionId || client?.sessions?.[0]?.id || "";
}

function getTimeout(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

// true once a held session is active (or was already); false when there's none
export async function fetchIsSessionActivated(clerk, preferredId = "") {
  const sessionId = getHeldSessionId(clerk, preferredId);
  if (!sessionId) return false;
  if (clerk.session?.id !== sessionId) {
    const activating = clerk.setActive({session: sessionId}).catch(() => {});
    await Promise.race([activating, getTimeout(ACTIVATE_TIMEOUT_MS)]);
  }
  return Boolean(clerk.session?.id || clerk.user);
}

const MESSAGES = {
  form_code_incorrect: "That code isn't right. Check it and try again.",
  verification_expired: "That code has expired. Press Start Again for a new one.",
  verification_failed: "Too many attempts. Press Start Again for a new code.",
  too_many_requests: "Too many attempts. Wait a moment, then press Start Again for a new code."
};

// a Clerk error, said plainly (unknown ones, e.g. "Invalid Action": start again)
export function getCodeErrorMessage(error) {
  const code = error?.errors?.[0]?.code;
  return MESSAGES[code] || "Something went wrong with that code. Press Start Again for a new one.";
}
